document.addEventListener('DOMContentLoaded', function () {
	const jQuery = window.jQuery || {};
	jQuery('.quote-slider').each(function () {
		let arrowClass = this.closest('.has-arrows') ? true : false;
		let slideCount = this.children.length;
		jQuery(this).slick({
			autoplaySpeed: 6000,
			speed: 1200,
			slidesToShow: 1,
			dots: slideCount > 1,
			variableWidth: true,
			arrows: arrowClass,
			infinite: true,
		});
	});
});
